import { useState, useEffect } from 'react';

/**
 * Hook für Motion-Reduction (WCAG 2.2)
 * Erkennt die Benutzereinstellung für reduzierte Animationen
 * Wichtig für Benutzer mit Vestibular-Störungen
 */
export function useReducedMotion() {
  const [prefersReducedMotion, setPrefersReducedMotion] = useState(false);

  useEffect(() => {
    // Prüfe die Media Query für prefers-reduced-motion
    const mediaQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
    
    // Setze den initialen Wert
    setPrefersReducedMotion(mediaQuery.matches);
    
    // Listener für Änderungen der Einstellung
    const handleChange = (event) => {
      setPrefersReducedMotion(event.matches);
    };
    
    // Event Listener hinzufügen
    mediaQuery.addEventListener('change', handleChange);
    
    // Cleanup
    return () => {
      mediaQuery.removeEventListener('change', handleChange);
    };
  }, []);

  return prefersReducedMotion;
}
